import api from '../../../App/socket';

export const getLeads = (params) => {
    const {
        limit,
        offset,
        vrm,
        ref_lead_source,
        waitingApproval,
    } = params;

    return api.send({
        api: 'module',
        module: 'Leads',
        classMethod: 'getLeadsWaitingPaymentsApproval',
        options: {
            limit,
            offset,
            where: {
                ref_lead_source,
                vrm,
                waitingApproval,
            },
        },
    });
};

export const countLeads = (params) => {
    const {
        vrm,
        ref_lead_source,
        waitingApproval,
    } = params;

    return api.send({
        api: 'module',
        module: 'Leads',
        classMethod: 'getLeadsWaitingPaymentsApproval',
        options: {
            where: {
                ref_lead_source,
                vrm,
                waitingApproval,
            },
            isCount: true,
        },
    });
};



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/requests/getLeads.request.js